import {
  LOG_OUT,
  ADMIN_SET_VENDOR_ONBOARD_DETAILS,
  ADMIN_SET_VENDOR_ONBOARD_CHAIN,
  ADMIN_SET_VENDOR_SUBCRIPTION,
} from "../../types";

const initialState = {
  admin_vendor_onboarding_details: {},
  admin_vendor_subscription_details: {},
  admin_vendor_onboarding_chain: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case ADMIN_SET_VENDOR_ONBOARD_DETAILS:
      return {
        ...state,
        admin_vendor_onboarding_details: action.payload,
      };
    case ADMIN_SET_VENDOR_SUBCRIPTION:
      return {
        ...state,
        admin_vendor_subscription_details: action.payload,
      };
    case ADMIN_SET_VENDOR_ONBOARD_CHAIN:
      return {
        ...state,
        admin_vendor_onboarding_chain: action.payload,
      };

    case LOG_OUT: {
      return {
        ...state,
        admin_vendor_onboarding_details: {},
        admin_vendor_subscription_details: {},
        admin_vendor_onboarding_chain: [],
      };
    }
    default:
      return state;
  }
}
